import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { validateResponseHasSchema } from '@/shared/api/validation'
import { z } from 'zod'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export const fetchActivityLog = (invoiceId: number) => validateResponseHasSchema(
  client.sendGet(`billing/invoices/${invoiceId}/activity`),
  z.object({
    data: z.array(
      z.object({
        activity: z.string(),
        userId: z.string().optional(),
        date: z.date({ coerce: true }),
        oldValue: z.string().nullable(),
        newValue: z.string().nullable()
      })
    )
  })
).then(r => r.data)
